import Parent from '@/creditflowresearch/ui/components/parent';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import getServerSideResearchData from '@/creditflowresearch/application/Research/serverSide/getServerSideResearchData';
import { DOCUMENT_GROUP_NAMES } from '@/creditflowresearch/domain/DocumentGroup';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import { getServerSideBondsTileData,
} from '@/creditflowresearch/application/Bonds/serverSide/getServerSideBondsTileData';
import {
  getServerSideTraceTileData,
} from '@/creditflowresearch/application/Trace/serverSide/getServerSideTraceTileData';
import getServerSideTopCompany from '@/creditflowresearch/application/TopCompanies/serverSide/getServerSideTopCompany';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import getServerSideChartData from '@/creditflowresearch/application/MarketChart/serverSide/getServerSideChartData';
import * as FILTER_TYPES from '@/creditflowresearch/application/PageFiltersState/constants';
import ParentPageContextProvider from '@/creditflowresearch/application/ParentPageContext';
import { pageNotFound, pageRedirectTo } from '@framework/router/Next/helpers';
import withCompanyByIdlProps from '@/creditflowresearch/application/Company/withCompanyByIdlProps';
import getServerSideSponsorBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideSponsorBreadcrumbs';
import getServerSideArticlesTile
  from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/serverSide/getServerSideArticlesTile';
import getQueryParamsWithProductsRegions from '@/creditflowresearch/application/helpers/getQueryParamsWithProductsRegions';
import Region from '@/creditflowresearch/domain/Region';
import { Product } from '@/creditflowresearch/domain/Product';
import { getProducts } from '@/creditflowresearch/application/Deal/helpers';
import getServerSideDealsByProduct from '@/creditflowresearch/application/Deal/helpers/utils/getServerSideDealsByProduct';
import getServerSideRoadshows from '@/creditflowresearch/application/Roadshows/serverSide/getServerSideRoadshows';

export const getServerSideProps = withCompanyByIdlProps(async (context) => {
  if (!context?.company.id) {
    return pageNotFound();
  }
  const { availableProductIds, activeProductId } = getProducts(context);

  const products = context.userPlanState.products.map(
    (productId) => Product.getAbbreviation(productId),
  ).filter(Boolean) as string[];
  const regions = context.userPlanState.regions.map(
    (regionId) => Region.getAbbreviation(regionId),
  ).filter(Boolean) as string[];
  const queryParams = getQueryParamsWithProductsRegions(
    context.query,
    ['companyViewId', 'sponsorName'],
    { products, regions },
  );

  if (queryParams) {
    return pageRedirectTo(`${ context.resolvedUrl }${ queryParams }`);
  }

  const [
    deals,
    topParents,
    breadcrumbs,
    researchData,
    chartData,
    bondTileData,
    traceTileData,
    articlesTilesData,
    roadshowsTileData,
  ] = await Promise.all([
    getServerSideDealsByProduct(context, {
      profileType: ProfileTypes.OVERVIEW,
      includedCompanyRole: FILTER_TYPES.PARENT,
      additionalFilters: {
        includedParentIds: [context?.company?.id],
      },
    }),
    getServerSideTopCompany(context),
    getServerSideSponsorBreadcrumbs(context, { products, regions }),
    getServerSideResearchData(context, { isTile: true, groupName: DOCUMENT_GROUP_NAMES.REPORTS }),
    getServerSideChartData(context, { filterType: FILTER_TYPES.PARENT }),
    getServerSideBondsTileData(context),
    getServerSideTraceTileData(context),
    getServerSideArticlesTile(context, { deal: null }),
    getServerSideRoadshows(context, { isTile: true }),
  ]);

  return ({
    props: {
      breadcrumbs,
      company: context?.company,
      topParents,
      deals,
      researchData,
      chartData,
      bondTileData,
      traceTileData,
      articlesTilesData,
      availableProductIds,
      activeProductId,
      roadshowsTileData,
    },
  });
});

const SponsorName = (props) => (
  <PageFiltersContextProvider
    company={ props?.company }
    profileType={ ProfileTypes.OVERVIEW }
  >
    <ParentPageContextProvider parentProps={ {
      topParents: props?.topParents,
      deals: props?.deals,
      research: props?.researchData,
      chartData: props?.chartData,
      traceTileData: props?.traceTileData,
      bondTileData: props?.bondTileData,
      articlesTilesData: props?.articlesTilesData,
      availableProductIds: props?.availableProductIds,
      activeProductId: props?.activeProductId,
      roadshowsTileData: props?.roadshowsTileData,
    } }
    >
      <PageContentLayout>
        <Parent />
      </PageContentLayout>
    </ParentPageContextProvider>
  </PageFiltersContextProvider>
);

export default SponsorName;
